export const APP_NAME = "Foodimus";
export const EMAIL_OPT_IN_PATH = "/email-opt-in";
export const PROCESSING_PATH = "/processing";
export const OFFER_PATH = "/personal-plan";
export const REDIRECT_PATH = "/redirect";
export const PAYMENT_OFFLINE_PATH = "/payment-offline";
export const PAYMENT_SUCCESS_PATH = "/payment-success";
export const TRIAL_DURATION = 7;
export const IP_STACK_ACCESS_KEY = "c201690c5ebc7662bcb241392d5db430";
